import { SceneSet } from '@bighealth/types';

export const getIsSceneAtEndOfSceneSet = (
  sceneSet: SceneSet | undefined,
  sceneId: number | undefined = 0
): boolean => sceneId === (sceneSet?.childNodes.length || 1) - 1;
